export default __webpack_public_path__ + "static/media/369labs.fd865d26.jpeg";